"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HashAlgorithm = void 0;
exports.hash = hash;
const jsrsasign_1 = require("jsrsasign");
var HashAlgorithm;
(function (HashAlgorithm) {
    HashAlgorithm["MD5"] = "md5";
    HashAlgorithm["SHA1"] = "sha1";
    HashAlgorithm["SHA224"] = "sha224";
    HashAlgorithm["SHA256"] = "sha256";
    HashAlgorithm["SHA384"] = "sha384";
    HashAlgorithm["SHA512"] = "sha512";
})(HashAlgorithm || (exports.HashAlgorithm = HashAlgorithm = {}));
function hash(payload, alg = HashAlgorithm.SHA256) {
    const hash = new jsrsasign_1.KJUR.crypto.MessageDigest({ alg });
    return hash.digestString(payload);
}
//# sourceMappingURL=hash.js.map